export default __webpack_public_path__ + "static/media/hc-8.fe3cd974.mp4";